import * as React from 'react';
import './style.scss';
import { Card } from 'components/card/card';
import { useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { getViaAuth, postViaAuth, responseValidator } from 'apis/api';
import { API } from 'apis';
import { Button, Checkbox, Spin } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { digitSperator } from 'core/utils/decimalExtentions';
import { Input } from 'components/input/input';
import { EditUserBalanceCard } from './card';
import { userWalletAssetsType, userWalletResponseType } from './type';

export const EditUserBalance: React.FC = () => {
    const location = useLocation();
    const userId = location.pathname.split('/')[location.pathname.split('/').length - 1];
    const [loading, setLoading] = useState(true);
    const [syncLoading, setSyncLoading] = useState(false)
    const [data, setData] = useState<userWalletResponseType>();
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [showWithBalance, setShowWithBalance] = useState(false);
    const [pageSize, setPageSize] = useState(8);
    const startIndex = (currentPage - 1) * pageSize;
    const assets = data?.assets || [];
    const filteredAssets = assets.filter((item) => {
        const matchesSearch =
            item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.symbol.toLowerCase().includes(searchTerm.toLowerCase());
        const hasBalance = showWithBalance ? item.balance !== 0 : true;
        return matchesSearch && hasBalance;
    });
    const currentAssets = filteredAssets.slice(startIndex, startIndex + pageSize);

    function fetchData() {
        if (userId)
            setLoading(true)
        getViaAuth<userWalletResponseType>(API.wallet.userWallet(userId))
            .then((res) => {
                if (responseValidator(res.status)) {
                    setData(res.value);
                }
            })
            .finally(() => setLoading(false));
    }
    useEffect(() => {
        fetchData();
    }, []);

    const syncWallet = () => {
        if (userId) {
            setSyncLoading(true)
            postViaAuth<any>(API.wallet.syncWallet, { userId: userId })
                .then((res) => {
                    if (responseValidator(res.status)) {
                        fetchData()
                    }
                })
                .finally(() => setSyncLoading(false))
        }
    }

    return (
        <Card className="edit-user-balance" title="تغییر اطلاعات کاربر">
            <Spin spinning={loading}>
                <div className="edit-user-balance-filters">
                    <div className="edit-user-balance-filters-input">
                        <Input
                            placeholder="جستجوی ارز..."
                            value={searchTerm}
                            onChange={(e) => {
                                setSearchTerm(e.target.value);
                                setCurrentPage(1);
                            }}
                        />
                        <Checkbox checked={showWithBalance} onChange={(e) => setShowWithBalance(e.target.checked)}>
                            نمایش ارز های دارای موجودی
                        </Checkbox>
                        <Button
                            type="primary"
                            icon={<ReloadOutlined spin={syncLoading} />}
                            onClick={syncWallet}
                            title="همگام‌سازی کیف پول"
                        >
                            همگام‌سازی
                        </Button>
                    </div>
                    <div className="edit-user-balance-filters-info">
                        <label>تمام موجودی‌:</label>
                        <p>
                            {digitSperator(data?.usdtBalance.toFixed(4))} دلار / {digitSperator(data?.irtBalance)} تومان
                        </p>
                    </div>
                </div>
                <div className="edit-user-balance-assets-container">
                    {data && data.assets.length > 0 && data.assets.find((i) => i.symbol === 'IRT') && (
                        <EditUserBalanceCard
                            userId={userId}
                            onConfirm={fetchData}
                            isPinned
                            item={data.assets.find((i) => i.symbol === 'IRT') as userWalletAssetsType}
                        />
                    )}
                    {currentAssets.length > 0 &&
                        currentAssets
                            .filter((i) => i.symbol !== 'IRT')
                            .map((item, index) => (
                                <EditUserBalanceCard userId={userId} onConfirm={fetchData} key={index} item={item} />
                            ))}
                    <div className="grid-guard" />
                    <div className="grid-guard" />
                    <div className="grid-guard" />
                </div>
            </Spin>
        </Card>
    );
};
